module.exports = __webpack_public_path__ + "img/fuki01_pc.357bf30e.png";